global.Promise = global.Promise || require('es6-promise').Promise;

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';

import routes from './routes.js';
import configureStore from './redux/configure-store.js';

const initialState = {};

const store = configureStore(initialState);

let rootElement = null;

if (process.env.DEVTOOLS) {
  const DevTools = require('./redux/DevTools');
  rootElement = (
    <Provider store={store}>
      <div>
        <Router>
          {routes}
        </Router>
        <DevTools/>
      </div>
    </Provider>
  );
}
else {
  rootElement = (
    <Provider store={store}>
      <Router>
        {routes}
      </Router>
    </Provider>
  );
}

ReactDOM.render(rootElement, document.getElementById('app-container'));



// WEBPACK FOOTER //
// ./src/bootstrap.js